import "react-big-calendar/lib/css/react-big-calendar.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SessionProvider } from "@/SessionContext";
import App from "@/App";
import Layout from "@layouts/Layout";
import ProtectedRoute from "@hooks/ProtectedRoute";
import "@/i18n";

// Public pages
import SignInSide from "@pages/SignInSide";
import SignUp from "@pages/SignUp";
import PaymentSuccess from "@pages/PaymentSuccess";
import PaymentError from "@pages/PaymentError";
import SubscriptionForm from "@pages/SubscriptionForm";
import ErrorPage from "@pages/notFound";

// User pages
import Dashboard from "@pages/user/dashboard/Dashboard";
import UserProfile from "@pages/user/profile/profile";
import MyTeam from "@pages/user/profile/myTeam";
import News from "@pages/user/news";
import DocumentsPage from "@pages/user/documents/Document";
import MyDocuments from "@pages/user/documents/MyDocuments";
import ChecklistList from "@pages/user/documents/ChecklistList";
import FormLayout from "@pages/user/newptw/FormLayout";
import AllObservations from "@pages/user/observations/allObservations";
import MyObservations from "@pages/user/observations/myObservations";
import NewObservation from "@pages/user/observations/newObservation";
import MyTodos from "@pages/user/observations/myToDos";

// Admin pages
import OrgSettings from "@pages/admin/organization/orgsettings";
import Sites from "@pages/admin/organization/sites";
import UserGroups from "@pages/admin/organization/usergroups";
import Departments from "@pages/admin/organization/departments";
import PtwSettings from "@pages/admin/ptw/ptwsettings";
import WorkFlowListView from "@pages/admin/ptw/workflows/workflowlist";
import Hazards from "@pages/admin/ptw/formdata/hazards";
import Precautions from "@pages/admin/ptw/formdata/precautions";
import PriorityLevels from "@pages/admin/ptw/formdata/priorityLevels";
import UserManagement from "@pages/admin/users/usermanagement";
import MyUserManagement from "@pages/admin/users/usersList";
import Communication from "@pages/admin/communication/communication";
import Announcement from "@pages/admin/communication/announcement";
import Archive from "@pages/admin/communication/archive";
import SearchUser from "@pages/admin/users/SearchUser";
import Organization from "@pages/admin/organization/organization";
import UserGuide from "@pages/UserGuide";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <SessionProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/sign-in" element={<SignInSide />} />
          <Route path="/sign-up" element={<SignUp />} />

          {/* Protected Routes */}
          <Route element={<App />}>
            <Route path="/subscription" element={<SubscriptionForm />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-error" element={<PaymentError />} />
            <Route
              element={
                <ProtectedRoute
                  allowedRoles={["ORG_USER", "ORG_ADMIN", "SUPERUSER"]}
                />
              }
            >
              <Route element={<Layout />}>
                <Route index path="/" element={<News />} />
                <Route path="home" element={<News />} />
                <Route path="analytics" element={<Dashboard />} />
                <Route path="profile" element={<UserProfile />} />
                <Route path="myteam" element={<MyTeam />} />
                <Route path="docs" element={<DocumentsPage />} />
                <Route path="doc/:documentId" element={<DocumentsPage />} />
                <Route path="mydocs" element={<MyDocuments />} />
                <Route path="check-lists" element={<ChecklistList />} />
                <Route path="newptw" element={<FormLayout />} />
                <Route path="observations" element={<AllObservations />} />
                <Route
                  path="observation/:observationId"
                  element={<AllObservations />}
                />
                <Route path="myobservations" element={<MyObservations />} />
                <Route path="newobservation" element={<NewObservation />} />
                <Route path="mytodos" element={<MyTodos />} />
                <Route path="user-guide" element={<UserGuide />} />

                {/* Admin Routes */}
                <Route
                  element={<ProtectedRoute allowedRoles={["ORG_ADMIN"]} />}
                >
                  <Route path="orgsettings" element={<OrgSettings />} />
                  <Route path="orgsettings/sites" element={<Sites />} />
                  <Route
                    path="orgsettings/departments"
                    element={<Departments />}
                  />
                  <Route
                    path="orgsettings/usergroups"
                    element={<UserGroups />}
                  />
                  <Route
                    path="orgsettings/organization"
                    element={<Organization />}
                  />
                  <Route path="riskregister" element={<PtwSettings />} />
                  <Route
                    path="riskregister/workflows"
                    element={<WorkFlowListView />}
                  />
                  <Route path="riskregister/hazards" element={<Hazards />} />
                  <Route
                    path="riskregister/precautions"
                    element={<Precautions />}
                  />
                  <Route
                    path="ptwsettings/formdata/priority"
                    element={<PriorityLevels />}
                  />
                  <Route path="usermanagement" element={<UserManagement />} />
                  <Route
                    path="usermanagement/userlist"
                    element={<MyUserManagement />}
                  />
                  <Route
                    path="usermanagement/search"
                    element={<SearchUser />}
                  />
                  <Route path="communications" element={<Communication />} />
                  <Route
                    path="communications/announcement"
                    element={<Announcement />}
                  />
                  <Route path="communications/archive" element={<Archive />} />
                </Route>
              </Route>
            </Route>
          </Route>

          {/* 404 */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </SessionProvider>
  </React.StrictMode>
);
